module.exports = __webpack_public_path__ + "jp.3de11154c8ffefb29e9d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/jp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/jp.svg
// module chunks = styles